var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"w-3 h-3 img-circle",attrs:{"src":_vm.logoSrc}})}
var staticRenderFns = []

export { render, staticRenderFns }